import React from 'react';
import ImageCard from '../ImageCard/ImageCard';

const Illustrations = () => (
    <ImageCard
        imageType="illustration"
        label="illustrations"
        words={['illustrations', 'vector art', 'clipart']}
    />
);

export default Illustrations;
